import {
  RestoredStep02ThematicPackagesData,
  Step02ThematicPackagesFormValues,
  UpdateThematicCampaignTargetingPayload,
} from '@features/campaigns/builder/containers/FormPages/Step02ThematicPackages/Step02ThematicPackages.types.ts';
import {
  createGeoTargetingPayloadDTO,
  restoreGeoOperationType,
} from '@features/campaigns/builder/shared/utils/geoTargeting.dto.ts';
import { CampaignDetails } from '@features/campaigns/shared/types/campaign.ts';
import { UserCountryCode } from '@shared/types/countryCodes.ts';

// Only called after validation, which guarantees a selected thematic package.
export function updateThematicCampaignTargetingDTO(
  formValues: Step02ThematicPackagesFormValues,
  country: UserCountryCode,
): UpdateThematicCampaignTargetingPayload {
  return {
    ...createGeoTargetingPayloadDTO(formValues, country),
    thematicPackage: { id: formValues.thematicPackageId ?? '' },
  };
}

export function restoreStep02ThematicPackagesDataDTO(data: CampaignDetails): RestoredStep02ThematicPackagesData {
  return {
    formData: {
      provinces: data.provinces,
      cities: data.cities,
      provincesOperationType: restoreGeoOperationType(data),
      thematicPackageId: data.thematicPackage?.id ?? null,
    },
    invalidSections: data.invalidSections,
    status: data.status,
    country: data.country,
  };
}
